import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AppContext = /*#__PURE__*/createContext(undefined);
export function AppProvider({
  appName,
  appId,
  currentUserId,
  children
}) {
  return /*#__PURE__*/_jsx(AppContext.Provider, {
    value: {
      appName,
      appId,
      currentUserId
    },
    children: children
  });
}
export function useApp() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
}